export const UserRoleType = {
    EDITSTORE:'TouchSoft.WebDashboard.Edit.Store',
    EDITCHAIN:"TouchSoft.WebDashboard.Edit.Chain",
    EDITCLUSTER:'TouchSoft.WebDashboard.Edit.Cluster',
    VIEWSTORE:'TouchSoft.WebDashboard.View.Store',
    VIEWCHAIN:'TouchSoft.WebDashboard.View.Chain',
    VIEWCLUSTER:'TouchSoft.WebDashboard.View.Cluster',
    MANAGER:'TouchSoft.WebDashboard.AccessLevel.Management',
    SUPPLIER_VIEW:'WebDashboard.Supplier.View',
    SUPPLIER_OWNER:'WebDashboard.Supplier.Owner',
}

    